// src/shared/components/layouts/MainLayout/MainLayout.tsx

import React, { useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "../Sidebar/Sidebar";
import { Header } from "../Header/Header";
import { useNavigation } from "../../../../features/navigation/hooks/useNavigation";
import { T } from "../../../../styles/tokens";
import { useSidebarAutoCollapse } from "../../../customHooks/useSidebarAutoCollapse";

import { useIsMobile } from "../../../customHooks/useIsMobile";
import { MobileSidebarDrawer } from "../Sidebar/MobileSidebarDrawer";
import { MobileHeader } from "../Header/MobileHeader";
import { MobileActionsDrawer } from "../Header/MobileActionsDrawer";
// import { useAppSelector } from "../../../../app/store";
// import { selectCurrentUser } from "../../../../features/auth/slices/authSlice";

const FULLSCREEN_PATHS = [
  "/routing/route-maker",
  "/routing/route-tracking",
  "/routing/security",
  "/routing/shuttle-tracking",
  "/routing/track-shift",
  "/routing/multiple-trip-view",
  "/routing/trip-life-cycle",
];

export const MainLayout: React.FC = () => {
  const { pathname } = useLocation();

  const isMobile = useIsMobile();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [mobileActionsOpen, setMobileActionsOpen] = useState(false);

  // ── ALL hooks must be called unconditionally, before any early returns ────
  useSidebarAutoCollapse();
  const { collapsed } = useNavigation();

  const isFullscreen = FULLSCREEN_PATHS.some(
    (p) => pathname === p || pathname.startsWith(p + "/"),
  );

  // Memoize styles so child components don't re-render on every parent render
  const sidebarW = collapsed
    ? T.layout.sidebarCollapsed
    : T.layout.sidebarExpanded;

  const contentStyle = useMemo<React.CSSProperties>(
    () => ({
      // marginLeft: sidebarW,
      marginLeft: isMobile ? 0 : sidebarW,
      transition: `margin-left var(--transition-normal)`,
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
    }),
    [sidebarW, isMobile],
  );


  // ── Fullscreen mode — bare canvas, no sidebar ─────────────────────────────
  if (isFullscreen) {
    return (
      <div style={{ width: "100vw", height: "100vh", overflow: "hidden" }}>
        <Outlet />
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: "var(--color-bg-page)" }}>
      {/* <Sidebar /> */}
      {isMobile ? (
        <>
          <MobileSidebarDrawer
            open={mobileNavOpen}
            onClose={() => setMobileNavOpen(false)}
          />
          <MobileActionsDrawer
            open={mobileActionsOpen}
            onClose={() => setMobileActionsOpen(false)}
          />
        </>
      ) : (
        <Sidebar />
      )}
      <div style={contentStyle}>
        {/* <Header /> */}

        {isMobile ? (
          <MobileHeader
            onMenuClick={() => setMobileNavOpen(true)}
            onActionsClick={() => setMobileActionsOpen(true)}
          />
        ) : (
          <Header />
        )}
        <main style={{ flex: 1, overflowY: "auto" }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};
